import React from 'react';
import { onClickBtnItemVariant } from 'actions/library/item';
import { connect } from 'react-redux';
import { getFormValues, change } from 'redux-form';
import classNames from 'classnames/bind';

import withFeatureFlag from 'hocs/withFeatureFlags';
import { isDisableOutletLevelForm } from 'utils/userProperties';
import ItemVariantSalesTypesFields from './ItemVariantSalesTypesFields';
import ItemVariantsFields from './ItemVariantsFields';
import ItemVariantEcommerce from './ItemVariantsFields/ItemVariantEcommerce';
import styles from './ItemVariantFieldArray.css';

class ItemVariantsFieldArray extends React.Component {
  render() {
    const {
      fields,
      isSalesTypePrice,
      businessLibraryMenu,
      itemDetail,
      ecommerceAttributes,
      ecommerceCategory,
    } = this.props;

    const isDisableForm = isDisableOutletLevelForm(
      businessLibraryMenu,
      itemDetail
    );

    const isClothing =
      ecommerceAttributes && ecommerceCategory.google_category_id === 166;

    const buttonContainerClass = classNames('form-group', 'col-sm-12', {
      'mt-10px': isClothing,
    });
    const buttonClass = classNames('btn', 'btn-primary', 'btn-block', {
      'no-border-radius-top': !isClothing,
    });

    const ItemVariantField = isClothing
      ? ItemVariantEcommerce
      : ItemVariantsFields;

    const isManageVariant = fields.length > 1;

    return (
      <div>
        <div className="row">
          {isClothing && isManageVariant && (
            <div className={`col-md-12 ${styles['manage-variant-container']}`}>
              <div>
                <button
                  onClick={this._onClickBtnItemVariant}
                  className={buttonClass}
                  disabled={isDisableForm}
                >
                  Edit Variant
                </button>
              </div>
            </div>
          )}
          {!isSalesTypePrice &&
            fields.map((member, index) => (
              <ItemVariantField
                fields={fields}
                member={member}
                key={index}
                index={index}
                ecommerceAttributes={isClothing}
                isDisableForm={isDisableForm}
              />
            ))}
          {isSalesTypePrice &&
            fields.map((member, index) => (
              <ItemVariantSalesTypesFields
                fields={fields}
                member={member}
                key={index}
                index={index}
                isDisableForm={isDisableForm}
                ecommerceAttributes={isClothing}
              />
            ))}
          {isClothing && !isManageVariant && (
            <div className={buttonContainerClass}>
              <button
                onClick={this._onClickBtnItemVariant}
                className={buttonClass}
                disabled={isDisableForm}
              >
                {this._buttonLabel()}
              </button>
            </div>
          )}

          {!isClothing && (
            <div className={buttonContainerClass}>
              <button
                onClick={this._onClickBtnItemVariant}
                className={buttonClass}
                disabled={isDisableForm}
              >
                {this._buttonLabel()}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }

  _onClickBtnItemVariant = e => {
    const { dispatch, item } = this.props;
    dispatch(onClickBtnItemVariant(item));
    if (item && item.item_variants) {
      const isEcommerce = item.item_variants.find(
        itemVariant => itemVariant.is_generated
      );
      if (isEcommerce) {
        dispatch(
          change('modal_item_variants', 'custom_category_variant', true)
        );
      }
    }
    e.stopPropagation();
    e.preventDefault();
  };

  _buttonLabel = () => {
    const { fields } = this.props;
    if (fields.length > 1) {
      return 'Manage Variant';
    }
    return 'Add Variant';
  };

  onChangeSalesType = event => {
    const { item } = this.props;
    if (event.target.checked) {
      item.item_variants.map(itemVariant => {
        if (
          !itemVariant.sales_type_items ||
          itemVariant.sales_type_items.length === 0
        ) {
          itemVariant.sales_type_items = [];
          const itemVariantSalesTypeIdList = itemVariant.sales_type_items.map(
            sti => sti.sales_type_id
          );
          item.sales_type.forEach(salesType => {
            if (itemVariantSalesTypeIdList.indexOf(salesType.id) === -1) {
              salesType.selected = true;
              itemVariant.sales_type_items.push({
                sales_type_id: salesType.id,
                sales_type_price: '',
              });
            }
          });
        } else {
          const itemVariantSalesTypeIdList = itemVariant.sales_type_items.map(
            sti => sti.sales_type_id
          );
          item.sales_type.forEach(salesType => {
            if (itemVariantSalesTypeIdList.indexOf(salesType.id) > -1) {
              salesType.selected = true;
            } else {
              itemVariant.sales_type_items.push({
                sales_type_id: salesType.id,
                sales_type_price: '',
              });
            }
          });
        }
      });
      this.props.dispatch(change('item', 'item_variants', item.item_variants));
    }
  };

  isHaveSalesType = () => {
    const { salesType } = this.props;
    return salesType.length > 0;
  };
}

function mapStateToProps(state) {
  const { itemDetail, ecommerceCategory } = state.library.item;
  const { salesType } = state.library.salesType;
  return {
    ecommerceCategory,
    itemDetail,
    item: getFormValues('item')(state),
    itemVariantsForm: getFormValues('modal_item_variants')(state),
    salesType,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapFlagToProps = flags => {
  return {
    businessLibraryMenu: flags.businessLibraryMenu,
    ecommerceAttributes: flags.ecommerceAttributes,
  };
};

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemVariantsFieldArray);

export default withFeatureFlag(mapFlagToProps)(connected);
